




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { status } from './timesheetStatus';
import { vxm } from '@/store.vuex';

@Component({
  name: 'TimeSheetDetail',
  components: {},
})
export default class TimeSheetDetail extends Vue {
  @Prop() timesheetdetails;
  @Prop() tabName;
  $moment: any;
  getDate(miliseconds) {
    return this.$moment(new Date(miliseconds)).format(
      vxm.jobs.getCompanyDateFormat.toUpperCase(),
    );
  }
  commentText(details) {
    if (this.tabName === status.SAVED || this.tabName === status.SUBMITTED) {
      return details.userComments;
    } else {
      return details.adminComments;
    }
  }
  commentHeader(tabName) {
    switch (tabName) {
      case status.SAVED:
      case status.SUBMITTED:
        return this.$t('timesheet-comments-text');
      case status.REJECTED:
        return this.$t('timesheet-rejection-comment-text');
      case status.APPROVED:
        return this.$t('timesheet-approved-comment-text');
      default: return '';  
    }
  }
}
